let controller = new AbortController()

export const getSignal = () => controller.signal

export const abortPendingRequests = () => {
  controller.abort()
  controller = new AbortController()
}
